<template>
  <div :class="['e6-header', { 'is-collapse': collapse }]">
    <div class="header__logo">
      <span
        :class="[$GLOBAL_CONFIG.icon === 'zhengzhou.ico' ? 'logo' : 'logo_gd']"
        :style="{ backgroundImage: `url(${headerLogo})` }"
      ></span>
      <span class="title">{{ $GLOBAL_CONFIG.home.title }}</span>
    </div>
    <!-- <div class="header__collapse">
          <i
            @click="handleCollapse()"
            :class="['icon-is-collapse', !collapse ? 'e6-icon-menu_open' : 'e6-icon-menu_off']"
          ></i>
        </div> -->
    <!-- 右侧 -->
    <section class="header__navbar">
      <slot name="navbar"></slot>
    </section>
    <el-dropdown
      class="header__user-setting"
      trigger="click"
      placement="bottom"
      @command="handleUserSetting"
    >
      <span class="el-dropdown-link">
        <span :title="userName" class="user-name">{{ userName }}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="2">修改密码</el-dropdown-item>
        <el-dropdown-item command="1"
          >{{ $t("_private.logout") }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- 修改密码 -->
    <el-dialog
      custom-class="e6-column-dialog"
      title="修改密码"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="490px"
    >
      <div class="column-wrapper">
        <el-form
          status-icon
          :model="ruleForm"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item
            label="原始密码"
            prop="oldPassword"
            :rules="[
              { required: true, message: '请输入原始密码', trigger: 'blur' }
            ]"
          >
            <el-input type="password" v-model="ruleForm.oldPassword"></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="newPassword"
            :rules="[
              { required: true, message: '请输入密码', trigger: 'blur' }
            ]"
          >
            <el-input
              type="password"
              v-model="ruleForm.newPassword"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="确认密码"
            prop="confirmPassword"
            :rules="[
              { required: true, message: '请确认密码', trigger: 'blur' }
            ]"
          >
            <el-input
              type="password"
              v-model="ruleForm.confirmPassword"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmitForm"
          >{{ $t("_private.button.confirm") }}
        </el-button>
        <el-button @click="handleCancelForm"
          >{{ $t("_private.button.cancel") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { FetchModifyPassword } from "_private/api/public";
import { mapGetters, mapActions } from "vuex";
// 头部菜单左侧logo
const headerLogo = require(`@/assets/images/${$GLOBAL_CONFIG.imageDirName}/header-logo.png`);

export default {
  props: ["collapse"],
  data() {
    return {
      headerLogo: Object.freeze(headerLogo), // 头部菜单左侧logo
      dialogVisible: false,
      ruleForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      }
    };
  },
  computed: {
    ...mapGetters(["userName"])
  },
  methods: {
    ...mapActions(["logoutAct"]),
    // 修改密码
    FetchModifyPassword(data) {
      FetchModifyPassword(data)
        .then(response => {
          this.submitCallback(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleCollapse() {
      this.$emit("update:collapse", this.collapse ? false : true);
    },
    handleUserSetting(e) {
      switch (e) {
        case "1":
          this.logout();
          break;
        case "2":
          this.dialogVisible = true;
          break;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitCallback(data) {
      let type = data.code === 1 ? "success" : "error";
      let message = data.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.dialogVisible = false;
            this.logout();
          }
        }
      });
    },
    handleSubmitForm() {
      this.FetchModifyPassword(this.ruleForm);
    },
    handleCancelForm() {
      this.dialogVisible = false;
      this.resetForm("ruleForm");
    },
    logout() {
      this.logoutAct();
      this.$router.push("/login");
      // 退出登录后，页面要重新刷新一下，为了解决动态路由重复添加
      location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_private/assets/styles/common/var.scss";
@import "_private/assets/styles/mixins/utils.scss";

$--header-height: 50px !default;
.e6-header {
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;
  color: $--menu-header-color;
  &.is-collapse {
    .header__logo {
      width: 0;
      overflow: hidden;
    }
    .header__collapse {
      margin-left: 0;
      .icon-is-collapse {
        margin-left: 22px;
      }
    }
  }
  .header__logo {
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -($--header-height/2);
    height: $--header-height;
    width: 420px;
    display: flex;
    align-items: center;
    flex-direction: row;
    // background-image: $--menu-logo;
    // background-position: 20px center;
    // background-repeat: no-repeat;
    // background-size: 289px 50px;
    font-size: 16px;
    text-align: center;
    transition: width 0.5s ease;
    .logo {
      // display: inline-block;
      width: 0.45rem;
      height: 0.37rem;
      // background-image: $--menu-logo;
      // background-position: 20px center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .logo_gd {
      width: 0.4rem;
      height: 0.4rem;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-left: 0.1rem;
    }
    .title {
      color: #fff;
      font-size: 26px;
      margin-left: 5px;
    }
  }
  .header__navbar {
    position: absolute;
    left: 420px;
    top: 0;
    height: 100%;
  }
  .header__user-setting {
    position: absolute;
    top: 50%;
    right: 15px;
    margin-top: -9px;
    color: $--menu-header-color;
    cursor: pointer;
    .user-name {
      display: inline-block;
      width: 80px;
      vertical-align: bottom;
      text-align: center;
      @include utils-ellipsis;
    }
  }
  .header__collapse {
    margin-left: ($--menu-width - 35);
    height: $--header-height;
    line-height: $--header-height;
    transition: margin-left 0.5s ease;
    .icon-is-collapse {
      font-size: 18px;
      margin-left: 15px;
      cursor: pointer;
    }
  }
  /deep/ .e6-column-dialog {
    .column-wrapper {
      padding: 40px 0 20px;
    }
    .el-form {
      margin-left: 20px;
      width: 400px;
    }
  }
}
</style>
